import React from "react";
import { Table, Badge } from "react-bootstrap";

const FutureTaskList = ({ data, taskJDs, onReload, onEdit, onDelete }) => {
  return (
    <div className="table-responsive">
      <Table hover align="middle" className="mb-0" style={{ fontSize: '0.75rem' }}>
        <thead className="bg-light text-muted text-uppercase">
          <tr>
            <th className="py-3">#</th>
            <th className="py-3">Task Code</th>
            <th className="py-3">Planned Detail</th>
            <th className="py-3">Execution Date</th>
            <th className="py-3">Status</th>
            <th className="py-3 text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item.id || index}>
                <td className="text-muted">{index + 1}</td>
                <td className="fw-bold text-primary">
                  {taskJDs?.find(j => String(j.id) === String(item.taskJDId))?.code || "N/A"}
                </td>
                <td style={{ maxWidth: '300px' }} className="text-wrap">{item.taskDetail}</td>
                <td>
                  <div className="fw-bold text-dark">{item.workDate?.substring(0, 10)}</div>
                  <small className="text-muted italic">{item.startTime} - {item.finishTime}</small>
                </td>
                <td>
                  <Badge bg="info" className="rounded-pill px-3 py-1 fw-normal">
                    {item.status || "Scheduling"}
                  </Badge>
                </td>
                <td className="text-center">
                  {/* NÚT EDIT */}
                  <button 
                    className="btn btn-sm text-info p-0 me-3 shadow-none border-0 bg-transparent"
                    title="Edit Plan"
                    onClick={() => onEdit && onEdit(item)}
                  >
                    <i className="fas fa-edit"></i>
                  </button>

                  {/* NÚT DELETE */}
                  <button 
                    className="btn btn-sm text-danger p-0 shadow-none border-0 bg-transparent"
                    title="Delete Plan"
                    onClick={() => onDelete && onDelete(item.id)}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-5 text-muted small italic">
                <i className="fas fa-calendar-day d-block mb-2 fa-2x opacity-25"></i>
                No future plans scheduled.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default FutureTaskList;